import React,{useState,useEffect} from 'react';
import { BrowserRouter, Switch,Route } from 'react-router-dom';
import LoginPage from './LoginPage'
import Home from './home'
import Problems from './problems'
import Submissions from './submissions'
import Friends from './friends'
import {auth} from './firebase'

function App() {
  const [loggedIn,setLoggedIn]=useState(false)
  
  const isLoggedIn=()=>{
    auth.onAuthStateChanged((user)=>{
      if(user){
        setLoggedIn(true)
      }
    })
  } 
  useEffect(()=>isLoggedIn(),[])


  return (
    <BrowserRouter>
      <Switch>
        <Route path='/' exact component={LoginPage}/>
        <Route path='/home' exact component={Home}/>
        <Route path='/problems' exact component={Problems}/>
        <Route path='/submissions' component={Submissions}/>
        <Route path='/friends' component={Friends}/>
      </Switch>
    </BrowserRouter>
  );


  
}

export default App;
